export const removeActionTypes = (requests: string[], action: string): string[] => {
  const _action = action.replace(/(REQUEST|SUCCESS|FAILURE)$/gi, '');
  return [ ...requests ].filter((requestAction) => {
    return !requestAction.startsWith(_action);
  });
};
